import { cloneDeep, set } from "lodash-es"
import React, { useState } from "react"
import CustomDialog from "components/Atoms/CustomDialog"
import ButtonMutation from "components/Molecules/ButtonMutation"
import { ApolloErrorToast, SuccessToast } from "utils/AppToaster"
import { ARRIVED_DOCK } from "graphql/dms/dms.mutations.gql"
import CustomFormGroup from "components/Atoms/CustomFormGroup"
import CustomDatePicker from "components/Atoms/CustomDatePicker"
import { Position } from "@blueprintjs/core"
import { TimePrecision } from "@blueprintjs/datetime"
const ArrivedVehicleDialog = ({ tripId, isOpen, onClose, ...otherProps }) => {
  const [state, setState] = useState({
    timestamp: new Date(),
  })

  function handleChange(path, value) {
    const stateCopy = cloneDeep(state)
    set(stateCopy, path, value)
    setState(stateCopy)
  }

  return (
    <CustomDialog
      title={
        <div>
          <text>Vehicle status</text>
        </div>
      }
      isOpen={isOpen}
      footerRightButton={
        <ButtonMutation
          icon="confirm"
          text="Yes"
          mutation={ARRIVED_DOCK}
          variables={{
            tripId,
            stepId: "10ac3986-cbad-425c-b0ed-0fd858b64a1a",
            timestamp: new Date(state.timestamp).toISOString(),
          }}
          onError={err => {
            ApolloErrorToast(err)
          }}
          onCompleted={() => {
            SuccessToast(`Success`)
            onClose()
          }}
        />
      }
      width="50%"
      onClose={onClose}
      {...otherProps}
    >
      <div>
        <CustomFormGroup label="Vehicle has arrived at dock at">
          <CustomDatePicker
            fill
            path="timestamp"
            format="MMMM Do YYYY, h:mm:ss A"
            label="Vehicle has arrived at dock at"
            valueAs="object"
            popoverProps={{
              minimal: true,
              position: Position.BOTTOM_RIGHT,
              popoverClassName: "vt-confirm-date-picker-popover",
            }}
            closeOnSelect={false}
            timePickerProps={{
              useAmPm: true,
              showArrowButtons: true,
              precision: TimePrecision.SECOND,
            }}
            value={state.timestamp}
            onChange={handleChange}
          />
        </CustomFormGroup>
      </div>
    </CustomDialog>
  )
}

export default ArrivedVehicleDialog
